import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';

export const SAppBar = styled(AppBar)({
    background: 'none',
    boxShadow: 'none',
});

export const SToolBar = styled(Toolbar)(({theme}) => ({
    justifyContent: 'end',
    paddingLeft: 0,
    paddingRight: 0,
    [theme.breakpoints.up('xs')]: {
        paddingLeft: 0,
        paddingRight: 0,
    },
}));

export const SMburger = styled(MenuIcon)({
    width:30,
    height:30
});
